import JSBI from 'jsbi';

// Took from: https://github.com/orca-so/typescript-sdk/blob/1c289193f69a5eb4b3ebc9f6f036d4ef81f17767/src/public/utils/models/percentage.ts
const SLIPPAGE_NUMERATOR = 10_000;
const SLIPPAGE_DENOMINATOR = 1_000_000;

const FEE_BPS_DENOMINATOR = 100_000;

export class Percentage {
  readonly numerator: JSBI;
  readonly denominator: JSBI;

  constructor(numerator: JSBI, denominator: JSBI) {
    this.numerator = numerator;
    this.denominator = denominator;
  }

  static fromSlippageNumber(num: number) {
    return new Percentage(
      JSBI.BigInt(num * SLIPPAGE_NUMERATOR),
      JSBI.BigInt(SLIPPAGE_DENOMINATOR)
    );
  }

  static fromFeeBpsNumber(num: number) {
    return new Percentage(JSBI.BigInt(num), JSBI.BigInt(FEE_BPS_DENOMINATOR));
  }

  public toString = (): string => {
    return `${this.numerator.toString()}/${this.denominator.toString()}`;
  };

  getFor(amount: JSBI): JSBI {
    const numerator = JSBI.BigInt(this.numerator.toString());
    const denominator = JSBI.BigInt(this.denominator.toString());

    return JSBI.divide(
      JSBI.multiply(amount, JSBI.subtract(denominator, numerator)),
      denominator
    );
  }

  getFrom(amount: JSBI): JSBI {
    const numerator = JSBI.BigInt(this.numerator.toString());
    const denominator = JSBI.BigInt(this.denominator.toString());

    return JSBI.divide(JSBI.multiply(amount, numerator), denominator);
  }
}
